// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  --logo-height: 2.25rem;
  --divider-width: 0.1rem;
  --divider-height: 2rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
  margin: 0 1rem;
}
.logo__app {
  height: var(--logo-height);
}
.logo__cobrand {
  height: var(--logo-height);
}
@media screen and (max-width: 900px) {
  .logo__cobrand {
    height: 1rem;
    flex-shrink: 0;
  }
  .logo__cobrand .logo__app {
    height: 1rem;
    display: block;
  }
  .logo:has(.logo__cobrand) {
    align-items: flex-end;
    gap: 0.75rem;
  }
}
@media screen and (max-width: 576px) {
  .logo {
    --logo-height: 1.75rem;
    --divider-height: 1.5rem;
    margin: 0;
  }
  .logo:has(.logo__cobrand) {
    gap: 0.5rem;
  }
  .logo__cobrand {
    height: 0.75rem;
  }
  .logo__cobrand .logo__app {
    height: 0.75rem;
  }
}
@media screen and (max-width: 370px) {
  .logo {
    --logo-height: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/site-logo/site-logo.component.scss"],"names":[],"mappings":"AAAA;EAEI,sBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,eAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAFJ;AAII;EACI,0BAAA;AAFR;AAKI;EACI,0BAAA;AAHR;AAMI;EACI;IACI,YAAA;IACA,cAAA;EAJV;EAMU;IACI,YAAA;IACA,cAAA;EAJd;EAQM;IACI,qBAAA;IACA,YAAA;EANV;AACF;AASI;EAvCJ;IAwCQ,sBAAA;IACA,wBAAA;IACA,SAAA;EANN;EAQM;IACI,WAAA;EANV;EASM;IACI,eAAA;EAPV;EASU;IACI,eAAA;EAPd;AACF;AAWI;EAzDJ;IA0DQ,qBAAA;EARN;AACF","sourcesContent":[".logo {\n\n    --logo-height: 2.25rem;\n    --divider-width: 0.1rem;\n    --divider-height: 2rem;\n\n    cursor: pointer;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1.25rem;\n    margin: 0 1rem;\n\n    &__app {\n        height: var(--logo-height);\n    }\n\n    &__cobrand {\n        height: var(--logo-height);\n    }\n\n    @media screen and (max-width: 900px) {\n        &__cobrand {\n            height: 1rem;\n            flex-shrink: 0;\n\n            .logo__app {\n                height: 1rem;\n                display: block;\n            }\n        }\n\n        &:has(.logo__cobrand) {\n            align-items: flex-end;\n            gap: 0.75rem;\n        }\n    }\n\n    @media screen and (max-width: 576px) {\n        --logo-height: 1.75rem;\n        --divider-height: 1.5rem;\n        margin: 0;\n\n        &:has(.logo__cobrand) {\n            gap: 0.5rem;\n        }\n\n        &__cobrand {\n            height: 0.75rem;\n\n            .logo__app {\n                height: 0.75rem;\n            }\n        }\n    }\n\n    @media screen and (max-width: 370px) {\n        --logo-height: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
